<div class="app-body">
  <main class="main d-flex align-items-center min-vh-100">
    <div class="container">
      <div class="col-md-5 mx-auto">
        <div class="card shadow-lg">
          <div class="card-body p-5">
            <h1>Login Verification Code</h1>
            <p class="text-muted">
              @if (mfaType === "GA") {
                <span>
                  Please verify your identity by providing the code, which you
                  will find in your
                  <strong>Google Authenticator</strong> App.
                </span>
              } @else {
                <span>
                  Please verify your identity by providing the code sent to you
                  via SMS.
                </span>
              }
            </p>
            @if (authenticationError) {
              <div
                class="alert"
                [ngClass]="isLocked ? 'alert-danger' : 'alert-warning'"
              >
                @if (isLocked) {
                  <strong>Maximum Attempts Exceeded!</strong>
                }
                @if (!isLocked) {
                  <strong>Verification failed!</strong>
                }
                <br />
                {{ errorMessage }}
                @if (!isLocked && attemptCount > 0) {
                  <br />
                }
                @if (!isLocked && attemptCount > 0) {
                  <span>
                    Attempt {{ attemptCount }} of {{ maxAttempts }}.
                    @if (attemptCount < maxAttempts) {
                      <strong
                        >{{ maxAttempts - attemptCount }} attempt(s)
                        remaining.</strong
                      >
                    }
                  </span>
                }
                @if (isLocked) {
                  <span>
                    <br />
                    @if (mfaType !== "GA") {
                      <span>Your verification code has been invalidated.</span>
                    }
                    Please log in again to receive a new code.
                    <br />
                    Redirecting to login screen...
                  </span>
                }
              </div>
            }

            <form (ngSubmit)="verifyTwoFactor()" class="form">
              <div class="mb-3">
                <label for="verificationCode">Verification Code</label>
                <input
                  #verificationCodeField
                  [(ngModel)]="verificationCode"
                  class="form-control"
                  id="verificationCode"
                  name="verificationCode"
                  type="text"
                  autocomplete="off"
                />
              </div>

              <button
                class="btn btn-primary"
                type="submit"
                [disabled]="saving || isLocked || !verificationCode?.trim()"
              >
                Verify
                @if (saving) {
                  <output
                    class="spinner-border spinner-border-sm"
                    aria-hidden="true"
                  ></output>
                }
              </button>
            </form>
            @if (mfaType === "EMAIL") {
              <div class="em">
                Our SMS provider is currently having issues,
                <b>please check your email</b> for your verification code.
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
